module.exports = __webpack_public_path__ + "static/media/57.bd5f7dfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/57.png
// module id = 482
// module chunks = 0